import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';

export const NotifyBodyC = () => {
    const breadcrumbLinks = [       
        { path: '/', label: 'Home' },
        { label: 'Notified Body Transition Details', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Notified Body Transition Details" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section className="service-details section-space">
  <div className="container">
    <div className="row flex-xl-row flex-column-reverse">
      <div className="col-xl-4">
        <div className="sidebar sidebar-rr-sticky">
          <div className="sidebar__widget-service mb-30">
            <Link to="/service">
              Medical Device Manufacturers <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/pharmaceutical-details">
              Pharmaceutical & Biotech Industry <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/healthcare-details">
              Healthcare Providers <i className="fa-solid fa-plus"></i>
            </Link>
          </div>

          <div className="sidebar__widget-contact__service text-center">
            <h4 className="mb-25 title-animation text-capitalize">
              Need Help with Medical Device Registration?
            </h4>
            <p className="mb-20">
              <a href="tel:+86 19811976744">
                <i className="fa-solid fa-phone"></i>(+86) 19811976744
              </a>
            </p>

            <Link to="/contact-us#" className="rr-btn">
              <span className="btn-wrap">
                <span className="text-one">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
                <span className="text-two">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className="col-xl-8">
        <div className="service-details__content">
          {/* Section Heading */}
          <div className="service-details__content-media mb-20">
            <img
              src="./assets/imgs/service-details/service-details-1.jpg"
              className="img-fluid"
              alt="img not found"
            />
          </div>
          <h2 className="title-animation mb-20">Notified Body Transition</h2>

<p className="mb-20">
  We offer a variety of solutions to efficiently manage transition projects. While each transition project is unique, our process remains consistent.
</p>
          <h3 className="title-animation mb-15"> Medical Device Registration</h3>
          <p>
            Medical device registration involves obtaining regulatory approval to market a device in a specific region. This process ensures that the device meets safety, efficacy, and quality standards set by local authorities. Successful registration is crucial for legal market entry and ongoing compliance.
          </p>

          {/* CE Registration */}
          <h4 className="title-animation mb-15"> <i className="fa-solid fa-vial text-primary"></i> CE Registration</h4>
          <p>
            In the EU, medical device manufacturers must demonstrate their compliance with the MDR (Medical Device Regulation) by meeting the General Safety and Performance Requirements (GSPRs) specified in these regulations. The conformity assessment procedures vary based on the risk class of the device (Class I, Im, Ir, Is, IIa, IIb, III for MDR).
          </p>
          <h4 className="title-animation mb-15">
    How SQUARE MEDTECH Can Help in CE Registration
</h4>
<ul className="mb-40">
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Regulatory Compliance Expertise
    </li>
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Conducting a GAP analysis of your existing technical documentation
    </li>
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Assisting with planning the required documentation for new products or projects
    </li>
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Documentation Preparation and Update
    </li>
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Providing support in creating all necessary technical documentation elements
    </li>
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Quality Management System (QMS) Integration
    </li>
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Training and Support
    </li>
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Cybersecurity and Software Documentation
    </li>
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Post-Market Surveillance (PMS) and Vigilance Reporting
    </li>
    <li>
        <span>
            <i className="fa-solid fa-check"></i>
        </span>
        Submission and Liaison with Regulatory Bodies
    </li>
</ul>
          <h5 className="title-animation mb-15">Risk Classes and Conformity Assessment Procedures</h5>
          <ul className="mb-30">
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>Class I Devices:</strong> Typically, manufacturers can self-certify these devices without the involvement of a Notified Body.
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>Class Im, Ir, Is, IIa, IIb, and III Devices:</strong> These higher-risk classes usually require the involvement of a Notified Body.
            </li>
          </ul>

          <h5 className="title-animation mb-15">Steps for Compliance</h5>
          <h6 className="mb-10">1. For Devices Requiring a Notified Body:</h6>
          <ul className="mb-30">
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>Conformity Assessment:</strong> Select and undergo the applicable conformity assessment procedure with a Notified Body.
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>Certificate of Conformity:</strong> Obtain a certificate of conformity from the Notified Body.
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>Declaration of Conformity:</strong> Prepare and sign a Declaration of Conformity.
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>CE Marking:</strong> Affix the CE mark to the device.
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>Additional Requirements:</strong> Fulfill all other items required in the conformity assessment procedure, such as technical documentation and post-market surveillance plans.
            </li>
          </ul>

          <h6 className="mb-10">2. For Devices Not Requiring a Notified Body:</h6>
          <ul className="mb-30">
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>Declaration of Conformity:</strong> Prepare and sign a Declaration of Conformity.
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>CE Marking:</strong> Affix the CE mark to the device.
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              <strong>Additional Requirements:</strong> Complete all items required in the selected conformity assessment procedure, including compiling technical documentation and conducting risk assessments.
            </li>
          </ul>


          <div className="row">
            <div className="col-lg-7">
              <div className="service-details__content-media-item service-details__content-media-item-1">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-2.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15"><i class="fa fa-circle-o text-danger"></i> Our Expertise in CE Registration </h4>
                <p>
                SQUARE MEDTECH specializes in CE registration, ensuring seamless regulatory compliance for medical devices. Our expertise includes technical documentation, clinical evaluation, risk assessment, and regulatory strategy. We navigate MDR requirements efficiently, facilitating faster approvals and market entry with precision, reliability, and adherence to European regulatory standards.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="service-details__content-media-item service-details__content-media-item-2">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-3.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15"><i class="fa fa-circle-o text-danger"></i> Why Choose Us for CE Registration</h4>
                <p>
                Choose SQUARE MEDTECH for CE registration expertise. We ensure compliance with MDR, streamline documentation, and expedite approvals, providing tailored regulatory strategies for seamless market entry with precision, efficiency, and reliability.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Service for Product Registration</h4>
                        <ul  class="color-white mb-0">
                        <li>Clinical Evaluation</li>
                        <li>Clinical Investigation</li>
                        <li>Regulatory Life Cycle</li>

                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Service for Product Registration</h4>
                        <ul  class="color-white mb-0">
                        <li>PMCF Solution</li>
                        <li>Healthcare Survey</li>
                        <li>EU MDR/FDA/ NMPA Consulting</li>
                      </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

    <FooterWhite/>

    </>
  )
}
